/**
 * @generated SignedSource<<79d2753eacd131ffcd06a533eba18b68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardFlightsCardUpdateStatus_flightsInfo$data = {
  readonly totalFailed: number;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsCardTable_flightsInfo">;
  readonly " $fragmentType": "DashboardFlightsCardUpdateStatus_flightsInfo";
};
export type DashboardFlightsCardUpdateStatus_flightsInfo$key = {
  readonly " $data"?: DashboardFlightsCardUpdateStatus_flightsInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsCardUpdateStatus_flightsInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardFlightsCardUpdateStatus_flightsInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalFailed",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardFlightsCardTable_flightsInfo"
    }
  ],
  "type": "DashboardFlightsInfo",
  "abstractKey": null
};

(node as any).hash = "58d0e3a7ea0bf1a42cb4cf23f09c2abf";

export default node;
